import IndiceRevisionDetailController from './indice.revision.detail.controller';

export default {
    template: require('./indice.revision.detail.html'),
    controller: IndiceRevisionDetailController
};
